import styled from 'styled-components';
import { flex, media } from '@/styles/theme';
import { Pen } from '@/assets/icons';

const Container = styled.div.attrs({
  className: `${flex.column}`,
})`
  &.show-default-view {
    ${media.tablet} {
      flex-direction: row !important;
    }
  }
`;

const CardContainer = styled.div<{ width?: string }>`
  width: 100%;
  flex: 1 0 120px;

  border: 1px solid #e5e7eb;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  border-radius: 8px;
  background-color: #fff;

  margin-right: 8px;
  margin-bottom: 14px;

  &:last-child {
    margin-right: 0;
  }
  &.show-default-view {
    &.hide-on-mobile {
      display: none;

      ${media.tablet} {
        display: inline-block;
      }
    }

    ${media.tablet} {
      width: ${({ width }) => width || '100%'};
      min-width: ${({ width }) => width || ''};
      flex: 0;
      min-height: 368px;
      margin-bottom: 32px;
    }
  }
`;

const HeaderLabel = styled.div.attrs({
  className: `${flex.columnCenter}`,
})`
  height: 50px;
  margin: 11px 4px 5px;
  text-align: center;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: #4b5563;
`;

const RowsContainer = styled.div.attrs({
  className: `${flex.column}`,
})<{ colorOne: string; colorTwo: string; colorText?: string }>`
  & > div {
    > div {
      background-color: ${({ colorOne }) => colorOne};
      color: ${({ colorText }) => colorText || '#000'};

      &.warning {
        background-color: #ffd8d8 !important;
        color: #b91c1c !important;
      }

      &.unpublished {
        background-color: #f3f4f6 !important;
        color: #374151 !important;
      }
    }

    :nth-child(2n) > div {
      background-color: ${({ colorTwo }) => colorTwo};

      &.warning {
        background-color: #fbe9e9 !important;
        color: #b91c1c !important;
      }

      &.unpublished {
        background-color: #f9fafb !important;
        color: #374151 !important;
      }
    }
  }
`;

const RowsLabelsContainer = styled.div.attrs({
  className: `${flex.row}`,
})`
  margin-top: 5px;
`;

const Row = styled.div.attrs({
  className: `${flex.row}`,
})`
  width: 100%;
  height: 100%;

  & > div {
    margin-right: 1px;

    &:last-child {
      margin-right: 0;
    }
  }

  &:only-child {
    & > div:first-child {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 7px;
    }

    & > div:last-child {
      border-top-right-radius: 8px;
      border-bottom-right-radius: 7px;
    }
  }

  &:not(:only-child) {
    &:first-child > div:first-child {
      border-top-left-radius: 8px;
    }

    &:first-child > div:last-child {
      border-top-right-radius: 8px;
    }

    &:last-child > div:first-child {
      border-bottom-left-radius: 7px;
    }

    &:last-child > div:last-child {
      border-bottom-right-radius: 7px;
    }
  }
`;

const EditReasonButton = styled.div`
  position: absolute;
  top: calc(50% - 9px);
  right: 12px;
  width: 18px;
  height: 18px;
  background-color: #323232;
  mask-image: url(${Pen});
  mask-repeat: no-repeat;
  mask-position: right;
  mask-size: contain;
  cursor: pointer;
`;

const RowCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;

  &.warning {
    > ${EditReasonButton} {
      background-color: #b91c1c !important;
    }
  }
`;

const RowLabelCell = styled.div.attrs({
  className: `${flex.centered}`,
})`
  width: 100%;
  // font-weight left on purpose
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #5a5a5a;
`;

export {
  Container,
  CardContainer,
  HeaderLabel,
  RowsContainer,
  RowsLabelsContainer,
  Row,
  EditReasonButton,
  RowCell,
  RowLabelCell,
};
